import React from "react";
import Accordions from "../../../components/Accordions";

const Sem1CSECS1 = () => {
  const data = [
    {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1vo-Ike8m0EwqdFWz370gHheVfkyA-fUi/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">CSECS Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1CSECS1;
